import { render, staticRenderFns } from "./bindAlipay.vue?vue&type=template&id=6ab34f8a&scoped=true&"
import script from "./bindAlipay.vue?vue&type=script&lang=js&"
export * from "./bindAlipay.vue?vue&type=script&lang=js&"
import style0 from "./bindAlipay.vue?vue&type=style&index=0&id=6ab34f8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab34f8a",
  null
  
)

component.options.__file = "bindAlipay.vue"
export default component.exports